import {
  PRODUCT_MODEL_DATA,
  PRODUCT_MODEL_DATA_SEPARATOR,
  PRODUCT_MODEL_KEY
} from 'models/daos/product/constants'
import { addDaysDatetimeUtil } from 'utils/datetime'
import { splitAndTrimAll } from 'utils/string'
import { pickObjectUtil } from 'packages/src'

const KEY_VALUE_SEPARATOR = ':'

/**
 * Gets the chunk array of a given chunk.
 * @private
 * @param   {string} chunk
 * @returns {String[]}
 */
function getKeyValueArr (chunk) {
  const arr = chunk.split(KEY_VALUE_SEPARATOR)
  if (arr.length > 2) {
    return [
      arr[0],
      arr.slice(1).join(':')
    ]
  }
  return arr
}

function productQuantitiesBeforeSave (value) {
  const chunks = splitAndTrimAll(value, PRODUCT_MODEL_DATA_SEPARATOR)
  const obj = {}
  chunks.forEach(chunk => {
    const chunkArr = getKeyValueArr(chunk)
    const key = chunkArr[0]
    const value = chunkArr[1]
    obj[key] = !isNaN(parseFloat(value)) ? parseFloat(value) : value
  })
  return obj
}

/**
 * Formats the promo codes before it gets saved.
 *
 * from:
 * ```js
 * '0.3:5'
 * ```
 *
 * to:
 * ```js
 * [{
 *   value: 0.3,
 *   expireAt: new Date // + 5 days
 * }]
 * ```
 * @private
 * @param  {string} value
 * @returns {Object[]}
 */
function promoCodesBeforeSave (value) {
  if (!value) {
    return
  }
  const keyValueArr = getKeyValueArr(value)
  return [
    {
      value: parseFloat(keyValueArr[0]),
      expireAt: addDaysDatetimeUtil(keyValueArr[1])
    }
  ]
}

function dataBeforeSave (value) {
  value = productQuantitiesBeforeSave(value)
  return pickObjectUtil(value, Object.values(PRODUCT_MODEL_DATA))
}

const PRODUCT_BEFORE_SAVE_HOOK = {
  [PRODUCT_MODEL_KEY.DATA]: dataBeforeSave,
  [PRODUCT_MODEL_KEY.PRODUCT_QUANTITIES]: productQuantitiesBeforeSave,
  [PRODUCT_MODEL_KEY.PROMO_CODES]: promoCodesBeforeSave
}

export {
  PRODUCT_BEFORE_SAVE_HOOK
}
